// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsExportAlpha = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:be7e4e95-33c6-4988-8b3c-98c623ccc9ca',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_6qQpEWwED',
  aws_user_pools_web_client_id: 'sqvp7effeju2uv1bj2nlqkguf',
  oauth: {
    domain: 'biocare-alpha.auth.us-east-2.amazoncognito.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn:
      'http://localhost:3001/,http://localhost:3001/login/,https://erp.alpha.bioflux.io/,https://erp.alpha.bioflux.io/login/',
    redirectSignOut:
      'http://localhost:3001/,http://localhost:3001/login/,https://erp.alpha.bioflux.io/,https://erp.alpha.bioflux.io/login/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [] as string[],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_mobile_analytics_app_id: '0854de30a30145a09582f3c85960fd54',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-pm-user-files110238-alpha',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const awsExportDelta = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:f8c49f59-acfc-4b22-863f-46492cd69b4f',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_2hsczDa77',
  aws_user_pools_web_client_id: '6ben1m57mkpb154f2vu3bm9vgq',
  oauth: {
    domain: 'btcy-acc-delta.auth.us-east-2.amazoncognito.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn:
      'http://localhost:3001/,http://localhost:3001/login/,https://erp.delta.bioflux.io/,https://erp.delta.bioflux.io/login/',
    redirectSignOut:
      'http://localhost:3001/,http://localhost:3001/login/,https://erp.delta.bioflux.io/,https://erp.delta.bioflux.io/login/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE', 'APPLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [] as string[],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_mobile_analytics_app_id: 'd888ef83fb14416ca7972e47fa8e9a73',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-pm-user-files115254-delta',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const awsExportStaging = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:75b892cd-6e8b-4aa4-858d-c7141980437f',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_6G7Kqtx8l',
  aws_user_pools_web_client_id: '7kaisoha3s3qaf0okac3es899r',
  oauth: {
    domain: 'btcy-acc-staging.auth.us-east-2.amazoncognito.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn:
      'http://localhost:3001/,http://localhost:3001/login/,https://erp.staging.biotricity.com/,https://erp.staging.biotricity.com/login/',
    redirectSignOut:
      'http://localhost:3001/,http://localhost:3001/login/,https://erp.staging.biotricity.com/,https://erp.staging.biotricity.com/login/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE', 'APPLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [] as string[],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_mobile_analytics_app_id: '8e222cb07ee44493bf2a291ec7067c8c',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-pm-user-files113004-staging',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const awsExportCustomer = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:d330654d-a73b-4a6f-93ff-595169d13abc',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_TvTmLHZb2',
  aws_user_pools_web_client_id: '468g25s3j4s14mrhlb6u93ln9s',
  oauth: {
    domain: 'biocare-customer.auth.us-east-2.amazoncognito.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn:
      'http://localhost:3001/,http://localhost:3001/login/,https://erp.customer.biotricity.com/,https://erp.customer.biotricity.com/login/',
    redirectSignOut:
      'http://localhost:3001/,http://localhost:3001/login/,https://erp.customer.biotricity.com/,https://erp.customer.biotricity.com/login/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [] as string[],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [] as string[],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_mobile_analytics_app_id: 'fb6aba88168a44e4a9749c20bc429153',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_user_files_s3_bucket: 'biocare-pm-user-files141256-customer',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

export { awsExportAlpha, awsExportDelta, awsExportStaging, awsExportCustomer };
